import type { ParticipationSettings as EditorParticipationSettings } from '@core-api/editor/types/response';
import type { ParticipationSettings as PresentationParticipationSettings } from '@core-api/presentation/types/response';
import type { Series } from '@mentimeter/legacy-series-types/series';
import { SLIDE_DECK_PARTICIPATION_RESPONSE_MODE_RESPONSES_BLOCKED } from '../../../constants';

export const participationModeSettingsToSeriesClosedForVoting = (
  participationSettings:
    | EditorParticipationSettings
    | PresentationParticipationSettings
    | undefined,
): Series['closed_for_voting'] => {
  return (
    participationSettings?.participationResponseMode ===
    SLIDE_DECK_PARTICIPATION_RESPONSE_MODE_RESPONSES_BLOCKED
  );
};
